/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiTimeseriesPoint = zod
	.object({
		avg_duration_ms: zod.number().describe('Average duration in ms'),
		errors: zod.number().describe('Failed requests'),
		p50_duration_ms: zod.number().describe('50th percentile duration in ms'),
		p95_duration_ms: zod.number().describe('95th percentile duration in ms'),
		requests: zod.number().describe('Total requests'),
		ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp')
	})
	.describe('API request timeseries data point');

export type ApiTimeseriesPoint = zod.input<typeof ApiTimeseriesPoint>;
export type ApiTimeseriesPointOutput = zod.output<typeof ApiTimeseriesPoint>;
